import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { PostReadingListArticleDto } from '../dtos/readingList/postReadingListArticle.dto';
import { ReadingListDto } from '../dtos/readingList/readingList.dto';
import { ReadingListArticleDto } from '../dtos/readingList/readingListArticle.dto';
import { PROFILES_MODULE_V1_URI } from '../services.constants';

export const getReadingListUri = (userId: string): string => `${PROFILES_MODULE_V1_URI}${userId}/reading-lists`;

export const fetchReadingList = async (): Promise<ReadingListDto[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.get(getReadingListUri(userId));
  return data;
};

export const createReadingList = async (readingListTitle: string): Promise<ReadingListDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.post<ReadingListDto>(getReadingListUri(userId), { name: readingListTitle });
  return data;
};

export const updateReadingList = async (readingList: ReadingListDto): Promise<ReadingListDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.put<ReadingListDto>(`${getReadingListUri(userId)}/${readingList.id}`, readingList);
  return data;
};

export const addReadingListArticle = async (
  readingListId: string,
  article: PostReadingListArticleDto
): Promise<ReadingListArticleDto> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error('Failed to get userId'));
  }
  const { data } = await api.post<ReadingListArticleDto>(
    `${getReadingListUri(userId)}/${readingListId}/articles`,
    article
  );
  return data;
};

export const removeReadingListArticle = async (readingListId: string, readingListItemId: string): Promise<void> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    await Promise.reject(new Error('Failed to get userId'));
    return;
  }
  await api.delete<void>(`${getReadingListUri(userId)}/${readingListId}/articles/${readingListItemId}`);
};
